<h1 mat-dialog-title class="dialog-title">{{ "DOWNLOAD_ERROR" | translate }}</h1>
<div mat-dialog-content>
  <p>{{ data.message | translate }}</p>
</div>
<div mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="onCloseClick()">Close</button>
</div>
